import apiFetch from '../apiFetch'

export default function (token, faqId, isPositive) {
  return apiFetch({ endPoint: `Faq/${faqId}/Vote`, method: 'PUT', body: isPositive, token: token })
}
